import { xs_languageCode } from "..";
import { getUrlPathSeo } from "./utils/getUrlPathSeo";
import { getUrlPathSeoSettings } from "./utils/getUrlPathSeoSettings";
import { parseBetsData } from "./parseBetsData";
import { getUrlPath } from "./util/getUrlPath";
import { byRanking } from './utils/byRanking';
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getPrematchAggs } from './utils/getPrematchAggs';
import { getSplitDesc } from './utils/getSplitDesc';

export function parseScorers(sport, tournament, matches, aggs) {
    const sportId = sport.id;
    const tournamentDesc = tournament.descrizione;

    const scorerAggs = [];
    const bets = [];
    {
        // Get the IDs of all scorer markets
        const betsSet = new Set();
        matches.forEach(m => {
            m.scs.forEach(b => betsSet.add(b.cs));
        });

        const filteredAggs = [];
        aggs.forEach(aggId => {
            const agg = getPrematchAggs(sportId, aggId);
            if (agg == null) {
                return null;
            }
            filteredAggs.push(agg);
        });
        filteredAggs.sort(byRanking);
        
        const aggsSet = new Set();
        filteredAggs.forEach(agg =>
            agg.scommesse.forEach(b =>  {
                if (!betsSet.has(b.id)) {
                    return;
                }

                const aggId = agg.idAggregata;
                if (!aggsSet.has(aggId)) {
                    scorerAggs.push(aggId);
                }
                bets.push(b);
            })
        );
    }

    let parsedMatches = [];
    if (scorerAggs.length > 0 || bets.length > 0) {
        matches.forEach(match => {
            const desc = match.dsl[xs_languageCode]
            const [team1, team2] = getSplitDesc(desc);
            const formattedDate = formatDateWithWeekDay(match.ts);
            const parsedMatch = {
                alias: match.al,
                avv: match.a,
                categoryRef: match.ic,
                date: formattedDate.dayMonthYear,
                dateShort: formattedDate.dayMonthShort,
                dateShortYear: formattedDate.dayMonthYearShort,
                desc: match.dsl[xs_languageCode],
                id: match.bid,
                isLive: match.lv,
                openAggregata: match.oa,
                openMacrogruppo: match.om,
                pal: match.p,
                plus: match.pl,
                sport: sportId,
                sportDesc: sport.descrizione,
                sportRef: sportId,
                tdesc: tournamentDesc,
                team1,
                team2,
                time: formatDate(match.ts).time,
                timestampDB: match.ts,
                tournamentDesc,
                tournamentRef: match.it
            };
    
            const bets = match.scs;
            const betsSet = new Set(bets.map(b => b.cs));
    
            const allAggId = -sportId;
            const uniqueId = `${tournament.uniqueId}_${match.bid}`;
            const matchData = {
                sportRef: tournament.sportRef,
                tournamentRef : match.it,
                pal: match.p,
                avv: match.a,
                id: match.bid,
                desc: desc,
                uniqueId,
                alias: match.al,
                sportDesc: sport.descrizione,
                tournamentDesc: tournament.descrizione,
                timestamp: match.ts,
                seoSettings: match.seo,
                seoSettingsAdds: match.seoa,
                urlPath: getUrlPath(tournament, match, desc),
                urlPathSeo: getUrlPathSeo({...match, seoSettings:match.seo}),
                urlPathSeoSettings: getUrlPathSeoSettings({...match, seoSettingsAdds: match.seoa})
            };
            const betsData = parseBetsData(matchData, [allAggId, ...scorerAggs], allAggId, bets, match.isLive, false);
            Object.assign(parsedMatch, betsData);
    
            parsedMatch.bets = betsData.bets.filter(b => betsSet.has(b.id));
            
            const betsById = betsData.betsById;
            betsById.forEach((bet, id) => {
                if (!betsSet.has(id)) {
                    betsById.delete(id);
                }
            });
            parsedMatch.betsById = betsById;
    
            parsedMatches.push(parsedMatch);
        });
    }

    return {
        bets,
        matches: parsedMatches
    };
}
